import OrderTable from 'e.sic-platform.webclient/src/components/shop/OrderTable';
import { observer } from "mobx-react-lite";

export default observer(function ActivityPricesTable() {

  return (
    <OrderTable />
  );
});
